import { cryptoParams } from 'config';
import is from 'is_js';
import dayjs from 'dayjs';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { EventEmitter } from 'events';
import { modal } from './components/modal/ModalContainer';

const crypto = require('crypto');
const event = new EventEmitter();

function md5(value) {
  const crypto = require('crypto');
  const md5 = crypto.createHash('md5');
  return md5.update(value).digest('hex');
}

function sha1(value) {
  const crypto = require('crypto');
  const sha1 = crypto.createHash('sha1');
  return sha1.update(value).digest('hex');
}

function encrypt(data) {
  if (!data) return null;
  try {
    let encrypted = '';
    const cipher = crypto.createCipheriv(...cryptoParams);
    encrypted += cipher.update(data, 'utf8', 'base64');
    encrypted += cipher.final('base64');
    return encrypted;
  } catch (error) {
    return null;
  }
}

function decrypt(data) {
  if (!data) return null;
  try {
    let decrypted = '';
    const cipher = crypto.createDecipheriv(...cryptoParams);
    decrypted += cipher.update(data, 'base64', 'utf8');
    decrypted += cipher.final('utf8');
    return decrypted;
  } catch (error) {
    return null;
  }
}

/**
 * From search string return a data object.
 * @param {*} search
 * @param {*} key
 * @returns
 */
function getQueries(search) {
  //!!! Don't using URLSearchParams,  because of encoding url

  const paramArr = search.slice(search.indexOf('?') + 1).split('&');
  const params = {};
  paramArr.map(param => {
    const [key, val] = param.split('=');
    if (key && val) params[key] = val;
  });
  return params;
}

/**
 *
 * @param {*} search
 * @param {*} key
 * @returns
 */
function getQuery(search, key) {
  const params = new Proxy(new URLSearchParams(search), {
    get: (searchParams, prop) => searchParams.get(prop)
  });
  return params[key];
}

/**
 * Load data from back end
 * @param {*} action
 */
function getMenuPath(corp, path) {
  if (corp && corp != 'y4') {
    const regx = new RegExp('/\\w+/', 'g');
    const t = regx.exec(path);
    if (t) {
      return `/${corp}/` + path.slice(regx.lastIndex);
    }
  }
  return path;
}

/**
 * Remove search stirng from route url
 *
 * @param route
 * @returns
 */
function getRoutePath(corp, route) {
  const r = getMenuPath(corp, route);
  const io = r.indexOf('?');
  if (io < 0) return r;
  return r.slice(0, io);
}

function isEmptyString(value) {
  return value == null || value == undefined || value == '';
}

function isNotEmptyString(value) {
  return (
    value != null &&
    value != undefined &&
    typeof value == 'string' &&
    value != ''
  );
}

function getValue(valueGetter, defaultValue = null) {
  try {
    return valueGetter();
  } catch (error) {
    return defaultValue;
  }
}

function textAlignToClass(y3Align) {
  if (_.endsWith(y3Align, 'Right')) {
    return 'text-end';
  } else if (_.endsWith(y3Align, 'Left')) {
    return 'text-start';
  } else if (_.endsWith(y3Align, 'Center')) {
    return 'text-center';
  } else {
    return '';
  }
}

function formatByNamedArgs(template, valueGetter) {
  if (!template) return null;
  if (!valueGetter) return template;
  if (!is.string(template)) return template;
  const regex = /{\w+}/g;
  return template.replaceAll(regex, k => {
    const key = k.substring(1, k.length - 1);
    if (_.isFunction(valueGetter)) {
      return isNullThenTo(valueGetter(key), '');
    } else {
      return isNullThenTo(valueGetter[key], '');
    }
  });
}

function isNullThenTo(value, defaultValue) {
  if (value == null || value == undefined) return defaultValue;
  return value;
}

function formatByArgs(template, ...args) {
  if (!template) return null;
  if (!args) return template;
  if (!is.string(template)) return template;
  const regex = /{\d+}/g;
  return template.replaceAll(regex, k => {
    const key = k.substring(1, k.length - 1);
    const index = parseInt(key);
    return isNullThenTo(args[index], '');
  });
}

function removeUi(data) {
  //remove "Ui" at field end
  const removed = _.mapKeys(data, (v, k) => {
    if (_.endsWith(k, 'Ui')) {
      const f = k.substring(0, k.length - 2);
      if (_.has(data, f)) {
        return k;
      } else {
        return f;
      }
    } else {
      return k;
    }
  });
  const trimed = _.mapValues(removed, v => {
    if (_.isString(v) && !/[\n\r\u2028\u2029]/.test(v)) {
      return _.trim(v);
    } else {
      return v;
    }
  });
  return trimed;
}

function removeRowsUi(rows) {
  if (_.isArray(rows)) {
    return rows.map(item => {
      return removeUi(item);
    });
  } else {
    return rows;
  }
}

/**
 * firstNotEmpty
 * @param  {...any} args
 * @returns
 */
function fne(...args) {
  if (is.empty(args)) return null;
  for (let i = 0; i < args.length; i++) {
    const e = args[i];
    if (is.existy(e) && is.not.empty(e)) {
      return e;
    }
  }
  return null;
}

/**
 * isEmptyPropertyThenTo
 * @param {*} o
 * @param {*} path
 * @param {*} defaultValue
 * @returns
 */
function ept(o, path, defaultValue) {
  const value = _.get(o, path);
  if (value == null || value == undefined) return defaultValue;
  return value;
}

/**
 * isEmptyThenTo
 * @param {*} value
 * @param {*} defaultValue
 * @returns
 */
function et(value, defaultValue) {
  if (value == null || value == undefined) return defaultValue;
  return value;
}

/**
 * Checks if the given string contains a substring.
 * @param {*} string
 * @param {*} subString
 * @returns
 */
function include(string, substring) {
  return is.include(string, substring);
}

/**
 * Auto remove Ui at field name end
 * @param {*} fieldName
 * @returns
 */
function getFieldName(fieldName) {
  if (_.endsWith(fieldName, 'Ui')) {
    return fieldName.slice(0, -2);
  } else {
    return fieldName;
  }
}

/**
 * Get property value by path
 *
 *
 * @param {*} o
 * @param {*} path: [{ 'b': { 'c': 3 } }] or a[0].b.c or 'a.b.c'
 * @returns
 */
function gpv(o, path, defaultValue = null) {
  return _.get(o, path, defaultValue);
}

/**
 * Set property value
 * @param {*} o
 * @param {*} path
 * @param {*} value
 */
function spv(o, path, value) {
  _.set(o, path, value);
}

/**
 *
 * @param {*} row
 * @param {*} encode
 * @returns
 */
function rowToOther(row, encode = true) {
  return toOther(
    {
      rows: [row]
    },
    encode
  );
}

/**
 *
 * @param {*} other
 * @returns
 */
function toOther(other, encode = true) {
  if (other == null) return null;
  const crypt = encrypt(JSON.stringify(other));
  if (encode) {
    return encodeURIComponent(crypt);
  } else {
    return crypt;
  }
}

/**
 *
 * @param {*} other
 * @returns
 */
function fromOther(other) {
  if (other == null) return null;
  return JSON.parse(decrypt(decodeURIComponent(other)));
}

/**
 * Merge objects to one
 * @param  {...any} objects
 * @returns
 */
function merge(...objects) {
  if (_.isEmpty(objects)) return null;
  let ro = null;
  objects.forEach(o => {
    if (o) {
      if (ro == null) ro = {};
      ro = { ...ro, ...o };
    }
  });
  return ro;
}

/**
 *
 * @param {*} predicate
 * @param  {...any} objects
 * @returns
 */
function mergeByPredicate(predicate, ...objects) {
  if (_.isEmpty(objects)) return null;
  let ro = {};
  objects.forEach(o => {
    if (o) {
      for (const p in o) {
        const v = o[p];
        if (predicate(p, v)) ro[p] = v;
      }
    }
  });
  return ro;
}

/**
 *
 * @param {*} url
 * @param {*} queries
 */
function appendQueries(url, queries) {
  if (!queries) return url;
  const sp = new URLSearchParams(queries);
  const qs = sp.toString();
  if (!url) return qs;
  const glue = include(url, '?') ? '&' : '?';
  return `${url}${glue}${qs}`;
}

/**
 * Navigate by window
 * @param {*} url
 * @param {*} queries
 */
function navigate(url, queries) {
  const root =
    window.location.href.split('/')[0] + process.env.REACT_APP_PUBLIC_URL;

  window.location.replace(appendQueries(`${root}${url}`, queries));
}

/**
 * If oFrom has value then set to oTo
 * @param {*} oFrom
 * @param {*} from
 * @param {*} oTo
 * @param {*} to
 */
function setIfHas(oFrom, from, oTo, to) {
  const v = _.get(oFrom, from);
  if (v) {
    _.set(oTo, to, v);
  }
}

function firstCharToUpper(s) {
  if (!s) return null;
  if (s.length == 1) return s.toUpperCase();
  return s.slice(0, 1).toUpperCase() + s.slice(1);
}

function joinValuesToString(array, key, format, split) {
  const a1 = _.flatMap(array, item => {
    return _.get(item, key);
  });
  const a2 = _.compact(a1);
  const a3 = a2.map(item => {
    return formatByArgs(format, item);
  });
  return _.join(a3, split);
}

/**
 *
 * @param {*} array
 * @param {*} key
 * @returns
 */
function sumPropertyOfObjects(array, key) {
  if (_.isEmpty(array)) return 0;
  let result = 0;
  for (const item of array) {
    const n1 = _.get(item, key);
    const n2 = Number(n1);
    result += n2;
  }
  return result;
}

function numberFormat(number) {
  return new Intl.NumberFormat().format(number);
}

function caseWhen(...functions) {
  if (_.isEmpty(functions)) return null;
  let l = functions.length;

  //only one
  if (l === 1) {
    const f = functions[0];
    if (_.isFunction(f)) {
      return f();
    } else {
      return f;
    }
  }

  //last function or value
  let lf = null;
  if (l % 2 === 1) {
    l -= 1;
    lf = functions[l];
  }

  for (let i = 0; i < l; i += 2) {
    const f = functions[i];
    const r = functions[i + 1];
    if (_.isFunction(f)) {
      if (f()) {
        if (_.isFunction(r)) return r();
        return r;
      }
    } else if (f) {
      if (_.isFunction(r)) return r();
      return r;
    }
  }

  if (lf) {
    if (_.isFunction(lf)) {
      return lf();
    } else {
      return lf;
    }
  }
  return null;
}

function isEmpty(value) {
  return _.isEmpty(value);
}

function isObject(value) {
  return _.isPlainObject(value);
}

function isArray(value) {
  return _.isArray(value);
}

function findInObject(o, predicate) {
  for (const p in o) {
    const v = o[p];
    if (predicate(v)) {
      return v;
    } else if (_.isPlainObject(v)) {
      const sv = findInObject(v, predicate);
      if (predicate(sv)) return sv;
    } else if (_.isArray(v)) {
      for (const av of v) {
        const sv = findInObject(av, predicate);
        if (predicate(sv)) return sv;
      }
    }
  }
  return null;
}

function getPanel(form, code, type = null) {
  return findInObject(form, o => {
    if (!_.isPlainObject(o)) return false;
    if (type) {
      return o.code === code && o.type === type;
    } else {
      return o.code === code;
    }
  });
}

function round(number, precision = 0) {
  return _.round(number, precision);
}

function setNavbarTopBadges(kind, badges) {
  event.emit('setNavbarTopBadges', { detail: { kind, data: badges } });
}

function setNavbarTopSearchBox(data) {
  event.emit('setNavbarTopSearchBox', { detail: { data } });
}

/**
 * Call f when predicate is true. try maxTimes times, each tring after time, the time in milliseconds.
 * @param {*} f
 * @param {*} predicate
 * @param {*} time
 * @param {*} maxTimes
 * @returns
 */
function until(f, predicate, time, maxTimes) {
  if (maxTimes <= 0) return;
  setTimeout(() => {
    if (predicate()) {
      f();
    } else {
      until(f, predicate, time, maxTimes--);
    }
  }, time);
}

function getSessionItem(key) {
  return decrypt(sessionStorage.getItem(key));
}
function setSessionItem(key, value) {
  sessionStorage.setItem(key, encrypt(value));
}
function removeSessionItem(key) {
  if (is.function(key)) {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (key(k)) {
        sessionStorage.removeItem(k);
      }
    }
  } else {
    sessionStorage.removeItem(key);
  }
}

function clearSession() {
  sessionStorage.clear();
}

function getLocalItem(key) {
  return decrypt(localStorage.getItem(key));
}
function setLocalItem(key, value) {
  localStorage.setItem(key, encrypt(value));
}
function removeLocalItem(key) {
  localStorage.removeItem(key);
}
function clearLocal() {
  localStorage.clear();
}

function clearBuffer() {
  removeSessionItem(k => {
    return (
      //_.endsWith(k, '_a') || //Authentication
      //_.endsWith(k, '_t') || //Token
      //_.endsWith(k, '_g') || //Global data
      //_.endsWith(k, '_w') || //Weixin
      //_.endsWith(k, '_tt') || //Toast list
      _.endsWith(k, '_d') || //Data of panel of form
      _.endsWith(k, '_f') || //Form
      _.endsWith(k, '_fp') || //Data of FilterPanel
      _.endsWith(k, '_atw') //Data of AdvanceTableWrapper.Inlude:pageIndex, pageSize, selectedRowIds, globalFilter
    );
  });
}

function min(...values) {
  return _.min(values);
}
function max(...values) {
  return _.max(values);
}

function clone(o) {
  if (o) {
    return JSON.parse(JSON.stringify(o));
  }
  return null;
}

function connectString(a, b, c) {
  if (!a) return b;
  if (!b) return a;
  if (_.endsWith(a, c) || _.startsWith(b, c)) return a + b;
  return a + c + b;
}

function setQueriesOther(form, queries) {
  if (form.other) {
    if (queries.other) {
      //TODO:union other form's and queries's
    } else {
      queries.other = toOther({
        rows: [removeUi(form.other)]
      });
    }
  }
}

function sort(array, field) {
  if (!is.array(array)) return array;
  return array.sort((first, second) => {
    const vf = gpv(first, field);
    const vs = gpv(second, field);
    if (vf == vs) return 0;
    if (vf < vs) return -1;
    return 1;
  });
}

function ifThen(condition, trueFunction, falseFunction) {
  if (condition) return trueFunction();
  return falseFunction();
}

function getCorpCode() {
  const p = window.location.pathname.split('/')[1];
  let corp = p ? p : 'y4';
  if (corp == 's') corp = 'y4';
  return corp;
}

function toastInfo(content, options) {
  toast.info(content, options);
  pushToastToList('info', content);
}

function toastSuccess(content, options) {
  toast.success(content, options);
  pushToastToList('success', content);
}

function toastWarn(content, options = { theme: 'colored' }) {
  toast.warn(content, options);
  pushToastToList('warn', content);
}

function toastError(content, options = { theme: 'colored' }) {
  if (content.length > 500) {
    options.style = { width: '440px' };
  } else if (content.length > 1000) {
    options.style = { width: '640px' };
  }
  toast.error(content, options);
  pushToastToList('error', content);
}

function getToastList() {
  const key = 'a9ebf7098c3413025ba36a05c8330550_tt';
  const array_json = getSessionItem(key);
  return array_json ? JSON.parse(array_json) : [];
}

function pushToastToList(type, content) {
  const key = 'a9ebf7098c3413025ba36a05c8330550_tt';
  const list = getToastList();
  const now = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
  list.push({ type, content, time: now });
  setSessionItem(key, JSON.stringify(list));
}

function isFullUrl(url) {
  try {
    const parsedUrl = new URL(url);
    //return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    return !!parsedUrl.protocol;
  } catch (error) {
    return false;
  }
}

/**
 * 忽略大小写从对象中获取属性值
 * @param {Object} obj - 要取值的对象
 * @param {string} propName - 要查找的属性名（大小写不敏感）
 * @returns {*} 属性值，找不到返回 null
 */
function getPropertyIgnoreCase(obj, propName) {
  // 边界判断：如果传入的不是对象或属性名不是字符串，直接返回 null
  if (typeof obj !== 'object' || obj === null || typeof propName !== 'string') {
    return null;
  }

  // 将目标属性名转为小写
  const targetProp = propName.toLowerCase();

  // 遍历对象的所有自有属性（不包含原型链上的属性）
  for (const key of Object.keys(obj)) {
    // 把对象的属性名也转为小写，进行匹配
    if (key.toLowerCase() === targetProp) {
      return obj[key];
    }
  }

  // 没有匹配到属性时返回 null
  return null;
}

/**
 * 验证字符串是否为有效的金额/数字格式
 * 支持：千位分隔符、小数点、负数、科学计数法、常见货币符号
 *
 * @param {string|number} value - 要验证的值
 * @returns {boolean} - 是否为有效的金额格式
 */
function isValidNumberFormat(value) {
  // 如果传入的是数字，直接返回 true（除了 NaN 和 Infinity）
  if (typeof value === 'number') {
    return isFinite(value);
  }

  // 如果不是字符串，转为字符串
  const str = String(value).trim();

  // 空字符串返回 false
  if (str === '') return false;

  // 移除货币符号（$、¥、€、£ 等）
  const withoutCurrency = str.replace(/^[$\u00A5\u20AC\u00A3\u20A9]?\s*/, '');

  // 移除千位分隔符（逗号）
  const withoutCommas = withoutCurrency.replace(/,/g, '');

  // 检查是否为有效的数字格式（支持科学计数法）
  // 正则说明：
  // ^           - 字符串开始
  // -?          - 可选的负号
  // \d+         - 至少一个数字
  // (\.\d+)?    - 可选的小数部分
  // (e[+-]?\d+)? - 可选的科学计数法（e 或 E）
  // $           - 字符串结束
  const numberRegex = /^-?\d+(\.\d+)?([eE][+-]?\d+)?$/;

  if (!numberRegex.test(withoutCommas)) {
    return false;
  }

  // 将字符串转为数字，检查是否为有限数字
  const num = Number(withoutCommas);
  return isFinite(num);
}

export default {
  md5,
  sha1,
  fne,
  et,
  ept,
  gpv,
  spv,
  merge,
  include,
  getFieldName,
  toOther,
  fromOther,
  rowToOther,
  removeUi,
  removeRowsUi,
  appendQueries,
  navigate,
  setIfHas,
  formatByNamedArgs,
  formatByArgs,
  firstCharToUpper,
  joinValuesToString,
  sumPropertyOfObjects,
  numberFormat,
  caseWhen,
  isEmpty,
  isObject,
  isArray,
  getPanel,
  toast,
  modal,
  event,
  _,
  is,
  dayjs,
  isEmptyString,
  isNotEmptyString,
  round,
  setNavbarTopBadges,
  setNavbarTopSearchBox,
  getQueries,
  getQuery,
  getValue,
  mergeByPredicate,
  until,
  getSessionItem,
  setSessionItem,
  removeSessionItem,
  clearSession,
  getLocalItem,
  setLocalItem,
  removeLocalItem,
  clearLocal,
  min,
  max,
  clone,
  connectString,
  sort,
  ifThen,
  getCorpCode,
  clearBuffer,
  toastInfo,
  toastSuccess,
  toastError,
  toastWarn,
  isFullUrl,
  getPropertyIgnoreCase,
  isValidNumberFormat
};

export {
  md5,
  sha1,
  encrypt,
  decrypt,
  getQueries,
  getQuery,
  isEmptyString,
  isNotEmptyString,
  et as isEmptyThenTo,
  ept as isEmptyPropertyThenTo,
  getValue,
  textAlignToClass,
  formatByNamedArgs,
  formatByArgs,
  removeUi,
  setQueriesOther,
  connectString,
  getRoutePath,
  getMenuPath,
  event,
  getToastList
};
